"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teardownScopedFocus = exports.setupScopedFocus = exports.returnFocus = exports.markForFocusLater = void 0;
var tabbable_1 = require("./tabbable");
var focusLaterElements = [];
var focusElement = null;
var needToFocus = false;
function handleBlur() {
    needToFocus = true;
}
function handleFocus() {
    if (needToFocus) {
        needToFocus = false;
        if (!focusElement) {
            return;
        }
        if (!focusElement) {
            return;
        }
        if (focusElement.contains(document.activeElement)) {
            return;
        }
        var el = tabbable_1.findTabbableDescendants(focusElement)[0] || focusElement;
        el.focus();
    }
}
function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
}
exports.markForFocusLater = markForFocusLater;
function returnFocus() {
    var toFocus = null;
    try {
        toFocus = focusLaterElements.pop();
        if (toFocus)
            toFocus.focus();
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn([
            '[@mantine/hooks/use-focus-trap] Focus was returned to',
            toFocus,
            'but dom node does not exist',
        ].join(' '));
    }
}
exports.returnFocus = returnFocus;
function setupScopedFocus(element) {
    focusElement = element;
    document.addEventListener('focusout', handleBlur, false);
    document.addEventListener('focusin', handleFocus, true);
}
exports.setupScopedFocus = setupScopedFocus;
function teardownScopedFocus() {
    focusElement = null;
    document.removeEventListener('focusout', handleBlur);
    document.removeEventListener('focusin', handleFocus);
}
exports.teardownScopedFocus = teardownScopedFocus;
